<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formImport">
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 fw-bold">
              <label>Para realizar el proceso de importación de ordenes de mantenimiento, descargue la guía y siga los
                pasos:</label>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6 col-12">
              <app-custom-autocomplete formControlName="companyId" [labelText]="'Compañía'" [list]="listCompanies"
                [required]="true" [recovery]="true" (onChangeSelect)="getCompany($event)">
              </app-custom-autocomplete>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6 col-12">
              <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event)">
              </app-custom-select>
            </div>
            <div class="col-lg-5 col-md-6 col-sm-6 col-12 d-flex align-items-end gap-2 mt-2">
              <div class="flex-shrink-0">
                <app-custom-button [title]="'Información.'" [severity]="'secondary'" [icon]="'pi pi-info-circle'"
                  (onClick)="openToggle($event)">
                </app-custom-button>
                <p-popover #information>
                  <span>
                    <b>Información</b>
                    <br>Este proceso revisa todas las ordenes de mantenimiento en el archivo de Excel.
                    <br>Si una orden de mantenimiento no existe, se crea automáticamente.
                    <br>Si una orden de mantenimiento ya existe, se actualiza con todos los valores diligenciados en el
                    excel.
                  </span>
                </p-popover>
              </div>
              <div class="flex-shrink-0">
                <app-custom-button [title]="'Seleccionar Archivo'" [label]="'Seleccionar Archivo'"
                  [severity]="'success'" [width]="'10rem'" [icon]="'pi pi-upload'" (onClick)="attach()"
                  [disabled]="!permissionUpdatable">
                </app-custom-button>
              </div>
              <div class="flex-grow-1">
                <input id="fileImport" type="file" (change)="getNameFile($event)" hidden>
                <p class="m-0 file-name">{{nameFile}}</p>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex align-items-end justify-content-between gap-2 mt-4">
              <app-custom-button [label]="'Descargar Guía Import.'" [severity]="'success'" [width]="'10rem'"
                [disabled]="!permissionUpdatable" (onClick)="downloadGuideImport()"></app-custom-button>
              <app-custom-button [label]="'Importar'" [severity]="'primary'" [disabled]="!permissionUpdatable"
                [variant]="undefined" (onClick)="importMaintenanceOrders()" [width]="'5rem'"></app-custom-button>
            </div>
          </div>
          <div class="row">
            <div id="list" *ngIf="visibleTxt">
              <h6>Lista de Errores y Alertas</h6>
              <p>Total errores: {{maintenanceOrdersAlerts.length}}</p>
              <div id="container-alerts" *ngFor="let maintenanceOrderAlert of maintenanceOrdersAlerts">
                <p [ngClass]="errorMaintenanceOrder == 1 ? 'message-error' : 'message-alert'">
                  {{maintenanceOrderAlert.message}}
                </p>
              </div>
            </div>
            <div class="row" *ngIf="visibleTxt">
              <div class="d-flex justify-content-end">
                <app-custom-button [title]="'Exportar'" [label]="'Exportar'" [icon]="'pi pi-file-export'"
                  [width]="'5.5rem'" (onClick)="downloadErrorsTxt()"></app-custom-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>